import React from "react";
import ReactDOM from "react-dom";
import "../css/ModalGenerico.css";

const ModalGenerico = ({
    show,
    onClose,
    titulo,
    children,
    footer,                    // ✅ nuevo: para botones de acción (opcional)
    className = "",
    disableClose = false,      // ✅ nuevo: para bloquear cierre durante loading (opcional)
    size = "md",               // ✅ nuevo: "sm" | "md" | "lg" | "xl" (opcional)
    onMinimize                 // ✅ nuevo: si se pasa, aparece el botón minimizar (opcional)
}) => {
    if (!show) return null;

    const handleClose = () => {
        if (!disableClose) onClose?.();
    };

    const sizeClass = `modal-size-${size}`;

    const botonCerrar = (
        <button
            className="modal-cerrar-btn"
            onClick={handleClose}
            disabled={disableClose}
            aria-label="Cerrar"
            style={disableClose ? { opacity: 0.5, cursor: "not-allowed" } : {}}
        >
            ✖
        </button>
    );

    return ReactDOM.createPortal(
        <div
            className="modal-overlay-generico"
            onClick={handleClose}
            aria-modal="true"
            role="dialog"
        >
            <div
                className={`modal-contenido-generico ${sizeClass} ${className}`}
                onClick={(e) => e.stopPropagation()}
                role="document"
            >
                <div className="modal-header-generico">
                    <h3>{titulo}</h3>
                    {onMinimize ? (
                        <div className="modal-header-acciones">
                            <button
                                type="button"
                                className="modal-minimizar-btn"
                                onClick={onMinimize}
                                aria-label="Minimizar"
                                title="Minimizar"
                            >
                                —
                            </button>
                            {botonCerrar}
                        </div>
                    ) : botonCerrar}
                </div>
                <div className="modal-body-generico">{children}</div>
                {footer && <div className="modal-footer-generico">{footer}</div>}
            </div>
        </div>,
        document.body
    );
};

export default ModalGenerico;